import React from 'react';
import TableControlPanel from './TableControlPanel';
import SystemComponent from './SystemComponent';

/**
 * DynamicColumnHeader component that integrates with SummaryTable's rendering approach.
 * Shows only toggle button when active; shows full control panel on hover when not active.
 * Updated to work with the new color option selection functionality.
 */
const DynamicColumnHeader = ({
  columnId,
  header,
  onToggleColumns,
  onToggleEncryption,
  onToggleColumnWidth,
  columnVisibility,
  setColumnVisibility,
  colorOption, // Replaces isCrucial - can be 'yellow', 'blue', or null
  onConditionChange,
  onColorOptionChange, // Replaces onCrucialChange
  isAllowedToChange,
  columnData,
  isActive,
}) => {
  // Modify header to remove subtitle when column is active/narrow
  const filteredHeader = React.useMemo(() => {
    if (!React.isValidElement(header) || !isActive) return header;
    
    // When active, keep only the first child (title) and remove others
    if (header.props && header.props.children && Array.isArray(header.props.children)) {
      const titleElement = header.props.children[0]; // First child should be title
      return React.cloneElement(
        header,
        { ...header.props },
        [titleElement] // Only include the title element as children
      );
    }
    return header;
  }, [header, isActive]);

  return (
    <div className="relative flex flex-col items-center w-full h-full group">
      {/* Header content */}
      <div
        className={`${isActive ? 'mt-0' : 'mt-1'} w-full text-center px-4`}
        style={{ paddingTop: isActive ? '25px' : '0' }}
      >
        {filteredHeader}
      </div>

      {/* System Component - only shown when not active/narrow */}
      {!isActive && (
        <div className="mt-2 w-full">
          <SystemComponent
            header="" // Don't show redundant header text
            selectedOption={colorOption} // Use the color option instead of isCrucial
            onConditionChange={onConditionChange}
            onSelectionChange={onColorOptionChange} // Use the new handler for color selection
            isAllowedToChange={isAllowedToChange}
            columnData={columnData}
            isActive={isActive}
            headersRotated={false}
            onColumnResizeToggle={() => onToggleColumnWidth(columnId, !isActive)}
          />
        </div>
      )}
    </div>
  );
};

export default DynamicColumnHeader;